import React from 'react';
import { useLanguage } from '../LanguageContext';

const WorkspacePicker = ({ workspaces, onSelect, onLogout }) => {
    const { t, isRtl } = useLanguage();
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f1f2f4',
            padding: 20,
            direction: isRtl ? 'rtl' : 'ltr'
        }}>
            <div style={{
                width: '100%',
                maxWidth: 500,
                background: '#fff',
                borderRadius: 16,
                padding: '40px 32px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e1e3e5'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 32 }}>
                    <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#1a1c1d' }}>{t.select_workspace}</h1>
                    <p style={{ margin: '8px 0 0', color: '#6d7175', fontSize: 14 }}>{t.choose_workspace}</p>
                </div>

                <div style={{ display: 'grid', gap: 12 }}>
                    {workspaces.map((ws) => (
                        <button
                            key={ws.workspaceId}
                            onClick={() => onSelect(ws.workspaceId)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '16px 20px',
                                background: '#f6f6f7',
                                border: '1px solid #e1e3e5',
                                borderRadius: 12,
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                textAlign: isRtl ? 'right' : 'left',
                                width: '100%',
                                flexDirection: isRtl ? 'row-reverse' : 'row'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = '#fff';
                                e.currentTarget.style.borderColor = '#1976d2';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = '#f6f6f7';
                                e.currentTarget.style.borderColor = '#e1e3e5';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{
                                width: 40, height: 40,
                                borderRadius: 10,
                                background: '#1976d2',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 18,
                                fontWeight: 700,
                                [isRtl ? 'marginLeft' : 'marginRight']: 16
                            }}>
                                {ws.name.charAt(0).toUpperCase()}
                            </div>
                            <div style={{ flex: 1, textAlign: isRtl ? 'right' : 'left' }}>
                                <div style={{ fontSize: 15, fontWeight: 600, color: '#1a1c1d' }}>{ws.name}</div>
                                <div style={{ fontSize: 12, color: '#6d7175' }}>{t.role}: {t[ws.role.toLowerCase()] || ws.role}</div>
                            </div>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#c9cccf', transform: isRtl ? 'rotate(180deg)' : 'none' }}>
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                    ))}
                </div>

                <div style={{ marginTop: 32, textAlign: 'center' }}>
                    <button
                        onClick={onLogout}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#d72323',
                            fontSize: 14,
                            fontWeight: 500,
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                    >
                        {t.sign_out_different_account}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WorkspacePicker;
